import styled from 'styled-components';
import theme from '../../../styles/defaultTheme';

export const Card = styled.div`
  display: flex;
  align-items: flex-end;
  margin-left: -25px;
  margin-bottom: 16px;

  & button {
    margin-bottom: 10px;
    height: 48px;
  }
`;

export const LinkCardContainer = styled.div`
  padding: 0;

  .MuiGrid-grid-xs-8 {
    margin-right: 24px;
  }
`;

export const ButtomCard = styled.button`
  width: 100%;
  max-width: 430px;
  min-height: 108px;
  text-align: left;
  background-color: ${(props) => props.theme.white};
  border: 1px solid ${(props) => props.theme.borderGreyLink};
  border-radius: 8px;
  cursor: pointer;
  outline: none;
`;

export const Title = styled.div`
  font-size: ${theme.font.size18};
  font-weight: bold;
  color: ${(props) => props.theme.orangeLink};
  text-align: left;
  margin-right: 10px;
`;

export const Desc = styled.div`
  font-size: ${theme.font.size14};
  color: ${(props) => props.theme.greyLink};
  text-align: left;
  margin-right: 10px;
`;
